import { useTranslate } from '@tolgee/react';
import DecorateTitle from 'components/DecorateTitle';
import { QuickChatControl } from 'components/QuickChatControl';
import SettingItemContainer from './SettingItemContainer';
import ThemeSelector from './ThemeSelector';
import { useThemeContext } from 'components/ThemesProvider';

export const ThemeColor = () => {
  const { t } = useTranslate();
  const themeCtx = useThemeContext();

  return (
    <QuickChatControl>
      <>
        <DecorateTitle>{t('aide.主题色')}</DecorateTitle>
        <SettingItemContainer>
          <ThemeSelector value={themeCtx.theme} onChange={themeCtx.onChange} />
        </SettingItemContainer>
      </>
    </QuickChatControl>
  );
};
